import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import axios from "axios";
import { shallowEqual, useSelector } from "react-redux";

const AddNewBranchModal = ({ show, onHide, onSuccess, student }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = useSelector((state) => state.auth.authToken, shallowEqual);
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  const handleHide = () => {
    setError(null);
    setLoading(false);
    onHide();
  };

  const handleSave = async () => {
    if (!student || !student.user_id) {
      setError("A student must be selected.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await axios.post(
        `/api/studentfamilybranch/add/${student.user_id}/${branch.branch_id}`,
        {
          headers: { "x-auth-token": token },
        }
      );

      if (onSuccess) {
        onSuccess();
      }
      handleHide(); 
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to add branch to student.";
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Branch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form>
          <Form.Group>
            <p>
              Add the <strong>{branch?.branch_name}</strong> location to <strong>{student?.firstname} {student?.lastname}</strong> and all other users associated to this profile.
            </p>
            <Form.Control
              type="hidden"
              placeholder="Enter branch name"
              value={branch?.branch_id || ""}
              autoFocus
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide} disabled={loading}>Cancel</Button>
        <Button variant="primary" onClick={handleSave}>
          {loading ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddNewBranchModal;